const CopyScheduleShifts = (function () {
  // Data
  let copyShiftParams;
  // DOM
  let copyShiftPopup;
  let locationDropdown,
    employeeDropdown,
    publishShiftsCheckbox,
    notifyEmployeesCheckbox,
    includeOpenShiftsCheckbox,
    selectMoreEmployeesBtn;
  let copyFromDateInputs, copyToDateInputs;
  let saveBtn;

  function sortEmployeeString(a, b) {
    const [aLast, aFirst] = a.text.split(',').map(s => s.trim());
    const [bLast, bFirst] = b.text.split(',').map(s => s.trim());

    const lastCmp = aLast.localeCompare(bLast, undefined, { sensitivity: 'base' });
    if (lastCmp !== 0) return lastCmp;

    return aFirst.localeCompare(bFirst, undefined, { sensitivity: 'base' });
  }
  async function populateEmployeeDropdown() {
    const shiftEmployees = (
      await _UTIL.fetchData('getEmployeeDropdownShiftDate', {
        locationId: '',
        toDate: '',
        fromDate: '',
      })
    ).getEmployeeDropdownShiftDateResult;

    const dropdownData = shiftEmployees.map(d => ({
      value: d.Person_ID,
      text: d.EmployeeName,
    }));
    dropdownData.sort(sortEmployeeString);

    dropdownData.unshift({
      value: 'null',
      text: '',
    });
    dropdownData.unshift({
      value: 'none',
      text: '(none)',
    });
    dropdownData.unshift({
      value: '%',
      text: 'All',
    });

    dropdown.populate(employeeDropdown, dropdownData, '');
  }
  function populateLocationDropdown() {
    const locations = SchedulingCalendar.getLocations();

    const dropdownData = locations
      .map(d => ({
        value: d.locationId,
        text: d.locationName,
      }))
      .filter(l => !l.id);

    dropdownData.unshift({
      value: 'null',
      text: '',
    });
    dropdownData.unshift({
      value: '%',
      text: 'All',
    });

    dropdown.populate(locationDropdown, dropdownData, '');
  }

  function checkRequiredFields() {
    var hasErrors = [].slice.call(copyShiftPopup.querySelectorAll('.error'));

    if (hasErrors.length === 0) {
      saveBtn.classList.remove('disabled');
    } else {
      saveBtn.classList.add('disabled');
    }
  }

  function handleDateChange() {
    if (!copyShiftParams.copyFrom.start || !copyShiftParams.copyFrom.end) {
      input.setValue(copyToDateInputs.start, '');
      input.disableInputField(copyToDateInputs.start);
      return;
    }

    input.enableInputField(copyToDateInputs.start);

    // make sure from start is before from end
    const isFromStartBeforeFromEnd = dates.isBefore(copyShiftParams.copyFrom.start, copyShiftParams.copyFrom.end);
    copyFromDateInputs.end.classList.toggle('error', !isFromStartBeforeFromEnd);

    if (!copyShiftParams.copyToFrom) {
      return;
    }

    // make sure from start is before to start
    const isFromStartBeforeToStart = dates.isBefore(copyShiftParams.copyFrom.start, copyShiftParams.copyTo.start);
    // make sure from end is before to start
    const isFromEndBeforeToStart = dates.isBefore(copyShiftParams.copyFrom.end, copyShiftParams.copyTo.start);
    // make sure both start dates are on same day of week
    const fromDatesSameDayOfWeek = copyShiftParams.copyFrom.start.day() === copyShiftParams.copyTo.start.day();
    copyToDateInputs.start.classList.toggle(
      'error',
      !isFromStartBeforeToStart || !fromDatesSameDayOfWeek || !isFromEndBeforeToStart,
    );
  }
  function handleFormChange({ target }) {
    switch (target) {
      case locationDropdown: {
        const selectedOption = target.options[target.selectedIndex];
        copyShiftParams.locationId = selectedOption.value;

        if (!copyShiftParams.locationId || copyShiftParams.locationId === 'null') {
          locationDropdown.classList.add('error');
          dropdown.setValue(employeeDropdown, 'null');
          input.disableInputField(employeeDropdown);
        } else {
          locationDropdown.classList.remove('error');
          input.enableInputField(employeeDropdown);
        }

        break;
      }
      case employeeDropdown: {
        const selectedOption = target.options[target.selectedIndex];
        copyShiftParams.employeeId = selectedOption.value;
        employeeDropdown.classList.toggle(
          'error',
          !copyShiftParams.employeeId || copyShiftParams.employeeId === 'null',
        );
        break;
      }
      case copyFromDateInputs.start: {
        copyShiftParams.copyFrom.start = target.value ? new Date(target.value) : '';
        copyFromDateInputs.start.classList.toggle('error', !copyShiftParams.copyFrom.start);

        handleDateChange();
        break;
      }
      case copyFromDateInputs.end: {
        copyShiftParams.copyFrom.end = target.value ? new Date(target.value) : '';
        copyFromDateInputs.end.classList.toggle('error', !copyShiftParams.copyFrom.end);
        handleDateChange();
        break;
      }
      case copyToDateInputs.start: {
        copyShiftParams.copyTo.start = target.value ? new Date(target.value) : '';
        copyToDateInputs.start.classList.toggle('error', !copyShiftParams.copyTo.start);
        handleDateChange();
        break;
      }
      case publishShiftsCheckbox: {
        copyShiftParams.publishShift = target.checked ? 'Y' : 'N';
        break;
      }
      case notifyEmployeesCheckbox: {
        copyShiftParams.notifyEmployees = target.checked ? 'Y' : 'N';
        break;
      }
      case includeOpenShiftsCheckbox: {
        copyShiftParams.includeOpenShifts = target.checked ? 'Y' : 'N';
        break;
      }
    }

    checkRequiredFields();
  }
  async function handleFormSubmit() {
    const success = (
      await _UTIL.fetchData('copyShifts', {
        locationId: copyShiftParams.locationId,
        employeeId: copyShiftParams.employeeId,
        copyFromFromDate: copyShiftParams.copyFrom.from,
        copyFromToDate: copyShiftParams.copyFrom.to,
        copyToFromDate: copyShiftParams.copyTo.from,
        copyToToDate: copyShiftParams.copyTo.to,
        notifyEmployee: copyShiftParams.notifyEmployee,
        publishShifts: copyShiftParams.publishShifts,
        includeOpenShifts: copyShiftParams.includeOpenShifts,
      })
    ).copyShiftsResul;

    showSuccessFailPopup(success);

    calendarEvents = await getCalendarEvents(selectedLocationId, selectedEmployeeId);
    renderCalendarEvents();

    POPUP.hide(pubUnpubPopup);
  }

  function showPopup() {
    copyShiftParams = {
      locationId: null,
      employeeId: null,
      copyFrom: {},
      copyTo: {},
      notifyEmployee: 'N',
      publishShifts: 'N',
      includeOpenShifts: 'N',
    };

    copyShiftPopup = POPUP.build({
      id: 'copyShiftPopup',
      header: 'Copy Shifts',
    });

    // Location Dropdown
    //------------------------------------------
    locationDropdown = dropdown.build({
      dropdownId: 'locationDropdown',
      label: 'Location',
      style: 'secondary',
    });

    // Dynamic Employee Section
    //------------------------------------------
    const dynamicEmployeeSection = document.createElement('div');
    dynamicEmployeeSection.classList.add('dynamicEmployeeSection');

    employeeDropdown = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee',
      style: 'secondary',
      classNames: 'disabled',
    });

    selectMoreEmployeesBtn = button.build({
      text: 'Select More Employees',
      style: 'secondary',
      callback: () => {
        showEmployeeMutliselectPopup(selectedEmployees => {
          if (selectedEmployees.length === 1) {
            // show dropdown
            dynamicEmployeeSection.classList.add('hidden');
            employeeDropdown.classList.remove('hidden');
            //todo set dropdown to value
          } else {
            // hide dropdown
            employeeDropdown.classList.add('hidden');

            dynamicEmployeeSection.classList.remove('hidden');
            dynamicEmployeeSection.innerHTML = `
              <div>
                <p>Selected Employees:</p>
                <p>${selectedEmployeesFromStupidMultiSelect}</p>
              </div>
            `;
          }
        });
      },
    });

    // Publish/Notify Checkboxes
    //------------------------------------------
    publishShiftsCheckbox = input.buildCheckbox({
      text: 'Publish Shifts',
      id: 'publishShifts',
      isChecked: false,
    });
    notifyEmployeesCheckbox = input.buildCheckbox({
      text: 'Notify Employees',
      id: 'notifyEmployees',
      isChecked: false,
    });
    includeOpenShiftsCheckbox = input.buildCheckbox({
      text: 'Include Open Shifts',
      id: 'includeOpenShifts',
      isChecked: false,
    });
    const checkboxWrap = document.createElement('div');
    checkboxWrap.classList.add('checkboxWrap');
    checkboxWrap.appendChild(publishShiftsCheckbox);
    checkboxWrap.appendChild(notifyEmployeesCheckbox);
    checkboxWrap.appendChild(includeOpenShiftsCheckbox);

    // Copy To/From Date Inputs
    //------------------------------------------
    copyFromDateInputs = {
      start: input.build({
        id: 'fromDateFrom',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'fromDateTo',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };

    copyToDateInputs = {
      start: input.build({
        id: 'toDateFrom',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'toDateTo',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };

    const fromDatesWrap = document.createElement('fieldset');
    const fromDatesLegend = document.createElement('legend');
    fromDatesLegend.textContent = 'Copy From:';
    fromDatesWrap.append(fromDatesLegend);
    fromDatesWrap.appendChild(copyFromDateInputs.start);
    fromDatesWrap.appendChild(copyFromDateInputs.end);

    const toDatesWrap = document.createElement('fieldset');
    const toDatesLegend = document.createElement('legend');
    toDatesLegend.textContent = 'Copy To:';
    toDatesWrap.append(toDatesLegend);
    toDatesWrap.appendChild(copyToDateInputs.start);
    toDatesWrap.appendChild(copyToDateInputs.end);

    // Buttons
    //------------------------------------------
    saveBtn = button.build({
      text: 'Save',
      style: 'secondary',
      type: 'contained',
      callback: handleFormSubmit,
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        POPUP.hide(pubUnpubPopup);
      },
    });
    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(saveBtn);
    buttonWrap.appendChild(cancelBtn);

    copyShiftPopup.append(locationDropdown);
    copyShiftPopup.append(dynamicEmployeeSection);
    copyShiftPopup.append(fromDatesWrap);
    copyShiftPopup.append(toDatesWrap);
    copyShiftPopup.append(checkboxWrap);
    copyShiftPopup.append(buttonWrap);

    populateLocationDropdown();

    copyShiftPopup.addEventListener('change', handleFormChange);

    POPUP.show(copyShiftPopup);
  }

  return {
    showPopup,
  };
})();
